import makeApi from '@/common/API';

const api = makeApi(() => window.env.SOCIAL.API_URL);

export default api;
